"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goldProviderConfig = void 0;
exports.goldProviderConfig = {
    name: 'mining-gold',
    fullname: 'Gold Extractor',
    description: 'Extracts gold ore from stones.',
    type: 'mining',
    width: 1,
    height: 1,
    levelMax: 5,
    canBeDisabled: true,
    requiredTechnology: 'gold',
    levels: [
        { level: 0, constructionCosts: {}, time: 100, provides: { 'gold-ore': 1 }, costs: { copper: 2, stone: 27, energy: 50 }, stores: {} },
        { level: 1, constructionCosts: { iron: 2000, copper: 4000 }, time: 80, provides: { 'gold-ore': 1 }, costs: { copper: 2, stone: 18, energy: 30 }, stores: {} },
        { level: 2, constructionCosts: { iron: 4000, copper: 8000 }, time: 40, provides: { 'gold-ore': 1 }, costs: { copper: 2, stone: 18, energy: 30 }, stores: {} },
        { level: 3, constructionCosts: { iron: 7000, copper: 10000 }, time: 20, provides: { 'gold-ore': 1 }, costs: { copper: 2, stone: 18, energy: 30 }, stores: {} },
        { level: 4, constructionCosts: { iron: 7000, copper: 10000, gold: 100 }, time: 8, provides: { 'gold-ore': 1 }, costs: { copper: 2, stone: 18, energy: 30 }, stores: {} },
        { level: 5, constructionCosts: { iron: 15000, copper: 20000, gold: 500 }, time: 1, provides: { 'gold-ore': 1 }, costs: { copper: 2, stone: 18, energy: 30 }, stores: {} },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/goldprovider.js
// module id = MbIw
// module chunks = 0